$(document).ready(() => {

	checkChatScreen();

	let CURRENT_LOGGED_USER_ID = "current_logged_user_id";

	// Abre o OrderChannel quando a tela tem o campo #current_order_channel e:
	// - é a tela de pagamento da assinatura (/subscription_payment), como antes; ou
	// - é a tela do pedido (/orders/:id) com o pedido aguardando pagamento
	//   (data-awaiting-payment="true"). Pedido pago/cancelado não abre conexão.
	function checkChatScreen(){
		let field = $("#current_order_channel");
		let current_order = field.val();
		if (current_order == null || current_order == ""){
			return;
		}

		let pathname = window.location.pathname;
		let subscriptionPayment = pathname.includes("/subscription_payment");
		let awaitingPayment = String(field.data("awaiting-payment")) == "true";
		if (subscriptionPayment || awaitingPayment){
			openChannelChat(current_order);
		}
	}

	function openChannelChat(current_order){
		(function() {
			this.App || (this.App = {});
			App.cable = ActionCable.createConsumer();
		}).call(this);
		
		App.room = App.cable.subscriptions.create(
		{
			channel: ("OrderChannel"),
			order_id: current_order
		},
		{
			connected: function() {
				console.log("OrderChannel connected (order_channel#" + current_order + ")");
			},
			disconnected: function() {},
			received: function(data) {
				if(data.action == "payment-done"){
					paymentConfirmed(data);
				} else if(data.action == "pix-due-date"){
					hideElement("current-payment", true);
					hideElement("new-payment", false);
				}
			},
			speak: function(current_order) {
				this.perform('speak', {
					order_id: current_order
				});
			}
		});
	}

	// O redirect do pedido comum (webhook PagBank) é a própria tela do pedido:
	// nesse caso recarrega para refletir o novo status; senão redireciona.
	function paymentConfirmed(data){
		if(data != null && data.redirect != null){
			alert("Pagamento realizado com sucesso!");
			if (data.redirect == window.location.pathname){
				window.location.reload();
			} else {
				window.location = data.redirect;
			}
		}
	}

	// setInterval(function () {
	// 	if(App.room){
	// 		let current_order = $("#current_order_channel").val();
	// 		App.room.speak(current_order);
	// 	}
	// }, 60000);

});
